export const authResult = can => (can ? 'APPROVED' : 'REJECTED')
